const VAR = '--q-drawer-gutter-width';

const root = () =>
  typeof document !== 'undefined' ? document.documentElement : null;

export const CSSVarQDrawerGutter = `var(${VAR}, 0px)`;

export const setQDrawerGutterWidth = (width: number): void => {
  if (width < 0 || isNaN(width) || !isFinite(width)) {
    console.warn('Invalid width for QDrawer gutter:', width);
    return;
  }
  const r = root();
  if (r) {
    r.style.setProperty(VAR, `${width}px`);
  } else {
    console.warn(
      'Document root is not available, cannot set CSS variable',
      VAR,
    );
  }
};
